<template>
  <h1 class="text-xs">
    <slot> </slot>
  </h1>
</template>

<script>
export default {
  name: "SmallTitle",
  components: {},
};
</script>

<style>
</style>